"use client"

import { useState } from "react"
import { useNavigate } from "react-router-dom"
import CommonAuthLayout from "../common/common-auth-layout/CommonAuthLayout"
import { getCompetitorDisplayName, getCompetitorSubLabel } from "../../lib/utils/hotelSearchMappers"
import "./SetupPage.css"

function CompetitorAvatar({ name }) {
  const initial = String(name || "?").trim().charAt(0).toUpperCase() || "?"
  return (
    <div className="competitor-img competitor-img--initial" aria-hidden="true">
      {initial}
    </div>
  )
}

const SetupPage = ({ hotelName, onboardingData = null, events = [] }) => {


  const displayHotelName =
    onboardingData?.hotel_name ||
    hotelName ||
    "Your Hotel"


  const [setupTime] = useState(2)
  const navigate = useNavigate()

  const handleSetupAccount = () => {
    if (typeof sessionStorage !== "undefined") {
      sessionStorage.setItem("settingup_from_onboarding", "1")
    }
    navigate("/settingup", { state: { onboardingData } })
  }

  const competitors = onboardingData?.competitors?.slice(0, 3) || []
  const sampleCalendar = onboardingData?.sample_content_calendar?.slice(0, 3) || []
  const recommendedTopics = onboardingData?.recommended_topics?.slice(0, 8) || []

  const upcomingEvents = events?.slice(0, 3) || []

  const notableTakeaways =
    onboardingData?.notable_takeaways?.slice(0, 3) || []


  const formatDateTime = (dateStr, timeStr) => {
    if (!dateStr || !timeStr) return "TBD"

    const date = new Date(dateStr)
    const today = new Date()
    const tomorrow = new Date(today)
    tomorrow.setDate(tomorrow.getDate() + 1)

    const [hours, minutes] = timeStr.split(":")
    const hour = Number.parseInt(hours)
    const ampm = hour >= 12 ? "PM" : "AM"
    const displayHour = hour % 12 || 12
    const formattedTime = `${displayHour}:${minutes} ${ampm}`

    if (date.toDateString() === today.toDateString()) {
      return `Today ${formattedTime}`
    } else if (date.toDateString() === tomorrow.toDateString()) {
      return `Tomorrow ${formattedTime}`
    } else {
      const dayName = date.toLocaleDateString("en-US", { weekday: "long" })
      return `${dayName} ${formattedTime}`
    }
  }

  const formatEventDate = (startDate, endDate) => {
    if (!startDate) return "TBD"

    const start = new Date(startDate)
    const options = { weekday: "short", day: "numeric", month: "short", year: "numeric" }

    if (endDate) {
      const end = new Date(endDate)
      const startStr = start.toLocaleDateString("en-US", options)
      const endStr = end.toLocaleDateString("en-US", options)
      return `${startStr} – ${endStr}`
    }

    return start.toLocaleDateString("en-US", options)
  }

  return (
    <CommonAuthLayout title="Setting up your space" showTitle={true}>
      <div className="setup-page-inner">
        <div className="setup-container">
          <div className="main-setup-card">
            <div className="left-side">
              <div className="w-row">
                <div className="mini-card competitor-card">
                  <h4 className="card-title">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8 3.5H11V6.5" stroke="#F54900" strokeLinecap="round" strokeLinejoin="round" />
                      <path
                        d="M11 3.5L6.75 7.75L4.25 5.25L1 8.5"
                        stroke="#F54900"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    Competitor Insights
                  </h4>
                  <div className="competitor-list">
                    {competitors.map((competitor, index) => {
                      const name = getCompetitorDisplayName(competitor)
                      const subLabel = getCompetitorSubLabel(competitor)
                      return (
                      <div key={competitor?.tripadvisor_url || competitor?.name || index} className="competitor-item">
                        <CompetitorAvatar name={name} />
                        <div className="competitor-info">
                          <h5>{name}</h5>
                          {subLabel ? <p>{subLabel}</p> : null}
                        </div>
                      </div>
                    )})}
                    <button className="compare-btn">Ready to compare</button>
                  </div>
                </div></div>

              <div className="w-row">
                <div className="mini-card calendar-card">
                  <h4 className="card-title">
                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_10894_146737)">
                        <path
                          d="M3.33398 0.832031V2.4987"
                          stroke="#155DFC"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M6.66602 0.832031V2.4987"
                          stroke="#155DFC"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M7.91667 1.66797H2.08333C1.6231 1.66797 1.25 2.04106 1.25 2.5013V8.33464C1.25 8.79487 1.6231 9.16797 2.08333 9.16797H7.91667C8.3769 9.16797 8.75 8.79487 8.75 8.33464V2.5013C8.75 2.04106 8.3769 1.66797 7.91667 1.66797Z"
                          stroke="#155DFC"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path d="M1.25 4.16797H8.75" stroke="#155DFC" strokeLinecap="round" strokeLinejoin="round" />
                      </g>
                      <defs>
                        <clipPath id="clip0_10894_146737">
                          <rect width="10" height="10" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    Sample Content Calendar
                  </h4>
                  <div className="calendar-list">
                    {sampleCalendar.map((item, index) => (
                      <div key={index} className="calendar-item">
                        <div className="calendar-left">
                          <button className="calendar-platform">{item.platform || "Instagram"}</button>
                          <h5>{item.campaign_name}</h5>
                          {/* <p className="calendar-stats">
                          {item.estimated_likes || "0"} {item.estimated_shares ? "shares" : "likes"}
                        </p> */}
                        </div>
                        <div className="calendar-right">
                          <p className="calendar-time">{formatDateTime(item.scheduled_date, item.scheduled_time)}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="gray-box">
                    <p>💡Your real calendar will generate based on your preferences</p>
                  </div>
                </div></div>

              <div className="w-row">
                <div className="mini-card events-card">
                  <div className="event-header">
                    <h4 className="card-title">🎉 Upcoming Events</h4>
                  </div>

                  <div className="event-boxes">
                    {upcomingEvents.length > 0 ? (
                      upcomingEvents.map((event, index) => (
                        <div key={event.id || index} className="event-box compact">
                          <div className="event-add-circle">+</div>
                          <h5>{event.title || event.name}</h5>
                          <p className="event-date">{formatEventDate(event.startDate || event.date, event.endDate)}</p>
                          {event.location && <p className="event-location">{event.location}</p>}
                        </div>
                      ))
                    ) : (
                      <p className="no-events">No upcoming events found</p>
                    )}
                  </div>

                  <p className="event-footer">🤖 AI suggests local events and creates post posters automatically</p>
                </div></div>

              <div className="w-row">
                <div className="mini-card topics-card">
                  <h4 className="card-title">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M8 10.5V9.5C8 8.96957 7.78929 8.46086 7.41421 8.08579C7.03914 7.71071 6.53043 7.5 6 7.5H3C2.46957 7.5 1.96086 7.71071 1.58579 8.08579C1.21071 8.46086 1 8.96957 1 9.5V10.5"
                        stroke="#9810FA"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M8 1.5625C8.42888 1.67368 8.8087 1.92413 9.07984 2.27453C9.35098 2.62493 9.4981 3.05544 9.4981 3.4985C9.4981 3.94156 9.35098 4.37207 9.07984 4.72247C8.8087 5.07287 8.42888 5.32331 8 5.4345"
                        stroke="#9810FA"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M11 10.5014V9.50141C10.9997 9.05827 10.8522 8.62779 10.5807 8.27756C10.3092 7.92733 9.92906 7.67719 9.5 7.56641"
                        stroke="#9810FA"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M4.5 5.5C5.60457 5.5 6.5 4.60457 6.5 3.5C6.5 2.39543 5.60457 1.5 4.5 1.5C3.39543 1.5 2.5 2.39543 2.5 3.5C2.5 4.60457 3.39543 5.5 4.5 5.5Z"
                        stroke="#9810FA"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    Content Topics for Your Hotel Type
                  </h4>
                  <div className="su-tags">
                    {recommendedTopics.map((tag, i) => {
                      const text =
                        typeof tag === "string" || typeof tag === "number"
                          ? String(tag)
                          : tag?.name ?? tag?.topic ?? tag?.title ?? ""
                      const displayText = text ? `#${text.replace(/^#/, "")}` : ""
                      if (!displayText) return null
                      return (
                        <span key={i} className="su-tag-truncated" title={displayText}>
                          {displayText}
                        </span>
                      )
                    })}
                  </div>
                </div></div>

            </div>

            <div className="right-side">
              <div className="right-insights-card">
                <h2 className="insights-title">
                  Here's what we found about {displayHotelName}
                </h2>


                <div className="insights-list">
                  {notableTakeaways.map((takeaway, index) => {
                    const text =
                      typeof takeaway === "string" || typeof takeaway === "number"
                        ? String(takeaway)
                        : takeaway?.text ?? takeaway?.description ?? takeaway?.title ?? ""
                    if (!text) return null
                    return (
                    <div key={index} className="insight-item">
                      <span className="insight-icon">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M16.5 8.31039V9.00039C16.4991 10.6177 15.9754 12.1914 15.007 13.4868C14.0386 14.7821 12.6775 15.7297 11.1265 16.1883C9.57557 16.6469 7.91794 16.5918 6.40085 16.0313C4.88376 15.4708 3.58849 14.435 2.70822 13.0782C1.82795 11.7214 1.40984 10.1164 1.51626 8.50262C1.62267 6.88881 2.24791 5.35263 3.29871 4.12319C4.34951 2.89375 5.76959 2.03692 7.34714 1.6805C8.92469 1.32407 10.5752 1.48714 12.0525 2.14539"
                            stroke="#29A155"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M16.5 3L9 10.5075L6.75 8.2575"
                            stroke="#29A155"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                      <p>{text}</p>
                    </div>
                  )})}
                </div>

                <div className="info-box">
                  <span className="info-icon">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z"
                        stroke="#2196F3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M9 13.5C11.4853 13.5 13.5 11.4853 13.5 9C13.5 6.51472 11.4853 4.5 9 4.5C6.51472 4.5 4.5 6.51472 4.5 9C4.5 11.4853 6.51472 13.5 9 13.5Z"
                        stroke="#2196F3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M9 10.5C9.82843 10.5 10.5 9.82843 10.5 9C10.5 8.17157 9.82843 7.5 9 7.5C8.17157 7.5 7.5 8.17157 7.5 9C7.5 9.82843 8.17157 10.5 9 10.5Z"
                        stroke="#2196F3"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                  <p>
                    We've created a comprehensive content calendar, competitor insights, and strategy templates designed
                    specifically for your hotel type, all set to enhance your post experience.
                  </p>
                </div>

                <div className="setup-timer">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                      stroke="#DC7D1B"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M12 6V12L14.5 16"
                      stroke="#DC7D1B"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  Setup: {setupTime} minutes remaining
                </div>

                <p className="setup-instruction">Just confirm a few quick details below to unlock your dashboard.</p>

                <button className="setup-button" onClick={handleSetupAccount}>
                  Let's set up your Account
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </CommonAuthLayout>
  )
}

export default SetupPage
